module.exports = __webpack_public_path__ + "img/fi-rr-key.c18b7c23.svg";